<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-black" id="nav">
        <div class="container-fluid position-relative">
            <!-- Left -->
            <div class="navbar-brand text-light">
                {{ leftText || " " }}
            </div>

            <!-- Center Logo -->
            <img
                src="@/../public/img/shiver.svg"
                alt="Shiver Logo"
                class="shiver-logo logo-center"
            />

            <!-- Toggler (mobile) -->
            <button
                v-if="!$route.path.startsWith('/ability-tree')"
                class="navbar-toggler"
                type="button"
                aria-label="Toggle navigation"
                @click="toggleCollapse"
            >
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- Collapsible content -->
            <div
                class="collapse navbar-collapse justify-content-end"
                id="navbarContent"
            >
                <div
                    class="d-flex flex-column flex-lg-row align-items-lg-center"
                >
                    <button
                        v-if="page !== 'roster'"
                        type="button"
                        class="btn btn-primary text-center ms-2 my-1"
                        @click="
                            $router.push({ name: 'Home' });
                            closeCollapse();
                        "
                    >
                        <font-awesome-icon icon="user" /> Cast List
                    </button>

                    <button
                        v-if="page !== 'stories'"
                        type="button"
                        class="btn btn-primary text-center ms-2 my-1"
                        @click="
                            $router.push({ name: 'Stories' });
                            closeCollapse();
                        "
                    >
                        <font-awesome-icon icon="film" /> Stories
                    </button>

                    <button
                        v-if="page === 'roster' && hasCompendium"
                        type="button"
                        class="btn btn-primary ms-2 my-1"
                        @click="
                            $router.push({ name: 'NewCharacter' });
                            closeCollapse();
                        "
                    >
                        <font-awesome-icon icon="plus" /> New
                    </button>

                    <button
                        v-if="page === 'encounter-manager' && hasCompendium"
                        type="button"
                        class="btn btn-primary ms-2 my-1"
                        data-bs-toggle="modal"
                        data-bs-target="#newEncounterModal"
                        aria-controls="newEncounterModal"
                    >
                        <font-awesome-icon icon="plus" /> New
                    </button>

                    <button
                        v-if="page === 'stories' && hasCompendium"
                        type="button"
                        class="btn btn-primary ms-2 my-1"
                        data-bs-toggle="modal"
                        data-bs-target="#newStoryModal"
                        aria-controls="newStoryModal"
                    >
                        <font-awesome-icon icon="plus" /> New
                    </button>

                    <button
                        v-if="!$route.path.startsWith('/ability-tree')"
                        class="btn btn-primary ms-2 my-1"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#compendiumMenu"
                        aria-controls="compendiumMenu"
                        @click="closeCollapse"
                    >
                        <font-awesome-icon icon="book" /> Menu
                    </button>
                </div>
            </div>
        </div>
    </nav>

    <!-- Offcanvas + settings -->
    <settings />
    <compendium-menu :page="page" />
    <new-encounter-modal />
    <new-story-modal />
</template>

<script>
import Settings from "./Settings.vue";
import CompendiumMenu from "./CompendiumMenu.vue";
import NewEncounterModal from "./NewEncounterModal.vue";
import NewStoryModal from "./NewStoryModal.vue";
import { useRosterStore } from "@/stores/index";

export default {
    name: "Navbar",
    components: {
        Settings,
        CompendiumMenu,
        NewEncounterModal,
        NewStoryModal,
    },
    props: {
        leftText: {
            type: String,
            required: true,
        },
        page: {
            type: String,
            required: true,
        },
    },
    computed: {
        hasCompendium() {
            const store = useRosterStore();
            return (
                store.archetypes.length > 0 ||
                store.abilities.length > 0 ||
                store.backgrounds.length > 0 ||
                store.backgroundAbilities.length > 0 ||
                store.flaws.length > 0
            );
        },
        encounterId() {
            const n = Number(this.$route.params.id);
            return Number.isFinite(n) ? n : undefined; // <-- undefined, not null
        },
    },
    methods: {
        toggleCollapse() {
            const el = document.getElementById("navbarContent");
            if (!el) return;

            const collapse =
                window.bootstrap.Collapse.getInstance(el) ||
                new window.bootstrap.Collapse(el, { toggle: false });

            if (el.classList.contains("show")) {
                collapse.hide();
            } else {
                collapse.show();
            }
        },
        closeCollapse() {
            const el = document.getElementById("navbarContent");
            if (el && el.classList.contains("show")) {
                const collapse = window.bootstrap.Collapse.getInstance(el);
                if (collapse) collapse.hide();
            }
        },
    },
};
</script>

<style>
#nav {
    grid-area: nav;
}

.navbar-brand {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.navbar-collapse {
    position: relative;
    z-index: 1;
}
.navbar-toggler {
    position: relative;
    z-index: 2;
}

.shiver-logo {
    height: 2.5rem;
    z-index: 1;
}

/* Absolute center logo */
.logo-center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0.25rem;
}

/* Adjust logo on mobile so it doesn’t overlap collapse */
@media (max-width: 992px) {
    .shiver-logo {
        height: 2rem;
        top: 0rem;
    }
}
</style>

